/* ============================================================
   Pure Vitamins UK - Shopify consent banner, moved to the left

   WHY JAVASCRIPT
   The stylesheet version of this, assets/pv-cookie.css, targeted
   #shopify-pc__banner and .shopify-pc__banner. Neither matched: the banner did
   not move. Shopify has changed this markup more than once and the class names
   in circulation online are out of date, so naming the element in a stylesheet
   is a guess. This script does not guess. It finds the element on the live
   page, measures it, and then decides what to change.

   HOW IT FINDS THE BANNER
   Known selectors first. If none match, it scans the top two levels of <body>
   for an element that is position:fixed, whose text contains the word cookie,
   whose text is short enough to be a banner rather than a page, and which
   contains a button or a link. All four conditions have to hold, which is what
   keeps it from grabbing something unrelated.

   TWO SHAPES, TWO TREATMENTS
   Consent banners come in two layouts and the fix differs:
     box ....... the fixed element IS the visible panel, anchored to a corner.
                 Set left and clear right, and it moves across.
     wrapper ... the fixed element spans the full width and the visible panel
                 is a child pushed to one side by the layout. Setting left on
                 the wrapper does nothing; the child's own alignment has to
                 change instead.
   The script measures the fixed element against the viewport width and picks.
   That measurement is the whole reason this is not CSS.

   WHAT IT WRITES
   In box mode: left and right. In wrapper mode: justify-content, align-items,
   text-align on the wrapper, and margin-left/margin-right on the panel. It
   never writes position, display, visibility, opacity, width or height, so it
   cannot make the banner disappear. If nothing matches, nothing happens and
   the banner stays where Shopify put it.

   DIAGNOSTICS
   window.PV_COOKIE reports which selector or scan matched, which mode was
   used and the measured width. Type PV_COOKIE in DevTools to see it.

   THE PROPER FIX IS STILL THE SETTING
   Settings, Customer privacy, Cookie banner, Position. It has no Admin API,
   which is why this file exists. If that setting is ever used, delete this
   file and its line in snippets/pv-head.liquid rather than running both.
   ============================================================ */

(function () {
  'use strict';

  var INSET_MOBILE = 12;
  var INSET_DESKTOP = 20;

  var state = { found: null, mode: 'not-run', width: 0, applied: 0 };
  window.PV_COOKIE = state;

  var KNOWN = [
    '#shopify-pc__banner',
    '.shopify-pc__banner',
    'shopify-privacy-banner',
    '[id*="privacy-banner"]',
    '[class*="privacy-banner"]',
    '[id*="shopify-pc"]'
  ];

  function isFixed(el) {
    try { return window.getComputedStyle(el).position === 'fixed'; }
    catch (e) { return false; }
  }

  /* Four conditions, all required. The length cap matters: without it, a fixed
     wrapper containing the whole page would qualify on the word cookie alone. */
  function looksLikeBanner(el) {
    var t = (el.textContent || '').toLowerCase();
    if (t.indexOf('cookie') === -1) return false;
    if (t.length > 1200) return false;
    return !!el.querySelector('button, a');
  }

  function findRoot() {
    var i, el;
    for (i = 0; i < KNOWN.length; i++) {
      try { el = document.querySelector(KNOWN[i]); } catch (e) { el = null; }
      if (el) { state.found = KNOWN[i]; return el; }
    }
    var all = document.querySelectorAll('body > *, body > * > *');
    for (i = 0; i < all.length; i++) {
      if (isFixed(all[i]) && looksLikeBanner(all[i])) {
        state.found = all[i].tagName.toLowerCase() + '.' + (all[i].className || '(no class)') + ' [scan]';
        return all[i];
      }
    }
    return null;
  }

  function widestChild(root) {
    var kids = root.children, best = null, i, w;
    for (i = 0; i < kids.length; i++) {
      w = kids[i].getBoundingClientRect().width;
      if (w > 0 && (!best || w > best.getBoundingClientRect().width)) best = kids[i];
    }
    return best;
  }

  function apply(root) {
    if (!root) return;

    var inset = window.innerWidth >= 768 ? INSET_DESKTOP : INSET_MOBILE;
    var rect = root.getBoundingClientRect();
    state.width = Math.round(rect.width);

    /* Within 10% of the viewport counts as full width, which allows for the
       page margin most wrappers carry. */
    if (rect.width >= window.innerWidth * 0.9) {
      root.style.setProperty('justify-content', 'flex-start', 'important');
      root.style.setProperty('align-items', 'flex-end', 'important');
      root.style.setProperty('text-align', 'left', 'important');

      var box = widestChild(root);
      if (box) {
        box.style.setProperty('margin-left', '0', 'important');
        box.style.setProperty('margin-right', 'auto', 'important');
      }
      /* Some builds nest the panel one level deeper than the widest child. */
      var inner = root.querySelector('div');
      if (inner && inner !== box) {
        inner.style.setProperty('margin-left', '0', 'important');
        inner.style.setProperty('margin-right', 'auto', 'important');
      }
      state.mode = 'wrapper';
    } else {
      root.style.setProperty('left', inset + 'px', 'important');
      root.style.setProperty('right', 'auto', 'important');
      state.mode = 'box';
    }
    state.applied++;
  }

  var root = null;

  function tick() {
    if (!root) root = findRoot();
    if (root) apply(root);
    return !!root;
  }

  /* The banner is injected by Shopify's consent script, which loads late, and
     on a repeat visit it may never appear at all. 24 seconds of polling. */
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (tick() || tries > 60) clearInterval(timer);
  }, 400);

  /* subtree:true here, unlike the chat script, because the banner is often
     mounted inside an existing container rather than appended to body. */
  if (window.MutationObserver && document.body) {
    new MutationObserver(function () { if (!root) tick(); })
      .observe(document.body, { childList: true, subtree: true });
  }

  var d;
  function onResize() {
    clearTimeout(d);
    d = setTimeout(function () { if (root) apply(root); }, 150);
  }
  window.addEventListener('resize', onResize);
  window.addEventListener('orientationchange', onResize);
})();